export const PRICE_RANGE_DESCRIPTION = Object.freeze({
  $: 'Low price',
  $$: 'Medium price',
  $$$: 'High price',
  $$$$: 'Very high price',
});
